import clsx from 'clsx';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import reframe, { useReframe } from 'nike-re-framejs';
import i18n from '@i18n';

import './DocumentUploader.less';

function bytes(value) {
    let ret = '';
    if (typeof value === 'number') {
        const kB = 1000;
        const MB = 1000 * kB;
        const GB = 1000 * MB;
        let unit = 'B';
        let v = value;
        if (value >= GB) {
            v = value / GB;
            unit = 'GB';
        } else if (value >= MB) {
            v = value / MB;
            unit = 'MB';
        } else if (value >= 1000) {
            v = value / kB;
            unit = 'kB';
        }
        ret = v.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1\u00a0');
        if (ret.endsWith('.00')) {
            ret = ret.substring(0, ret.length - 3);
        } else {
            ret = ret.replace('.', ',');
        }
        ret = `${ret}\u00a0${unit}`;
    }
    return ret;
}

// slot je klientsky interny index, slotName je hodnota pod ktoru sa subor bude uploadovat
export const SingleUpload = forwardRef(
    ({ idZak, slot, slotName, documentId, page, clientHash, help, limitFileSize = 5 * 1024 * 1024 }, ref) => {
        const derefSub = useReframe();
        const progress = derefSub(['documentsUpload.uploadProgress', slot, documentId, page]);
        const done = progress && progress.get('done');
        const [error, setError] = useState();
        // provides a way to set (server-side) errors
        useImperativeHandle(ref, () => ({ setError }));

        function onChange(e) {
            const file = e.target.files[0];
            const isImage = file.type && file.type.startsWith('image/');
            if (file && (isImage || file.size <= limitFileSize)) {
                const data = { idZak, slot, slotName, documentId, page, clientHash };
                reframe.dispatch(['documentsUpload.doUpload', data, file]);
                if (error) {
                    setError(null);
                }
            } else {
                setError(`${i18n('bankAccount.change.upload.fileSizeLimit')} ${bytes(limitFileSize)}.`);
            }
        }
        return (
            <div className={clsx('file-input', { done, invalid: error })}>
                <div className="file-input-area">
                    {progress ? (
                        <div className="file-input-preview">
                            {progress.get('resolvedType') === 'image' ? (
                                <img
                                    className="file-input-preview-img"
                                    src={progress.get('imageUrl')}
                                    alt="Náhľad dokumentu"
                                />
                            ) : null}
                            {progress.get('resolvedType') === 'pdf' ? <div className="file-input-preview-pdf" /> : null}
                            <div className="file-input-progress-bar" key={progress.get('filename')}>
                                <div className="progress-bar">
                                    <div
                                        className="progress-bar-in"
                                        style={{
                                            width: progress.get('progress') + '%',
                                            display: progress.get('progress') < 0 ? 'none' : 'block'
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="file-input-overlay">
                            <div className="file-bg" />
                        </div>
                    )}
                    <input
                        type="file"
                        name="myImage1"
                        accept=".png,.jpg,.jpeg,.pdf"
                        className="file-input-field"
                        key={Math.random()}
                        onChange={onChange}
                    />
                </div>
                {error ? <p className="error">{error}</p> : null}
                {help ? <p className="info" dangerouslySetInnerHTML={{ __html: help }} /> : null}
            </div>
        );
    }
);
